import { useEffect, useState } from "react";
import { Container, FormGrid, InputWrapper } from "./styles";
import InsertFee from "./components/insertFee/insertFee";
import OlderFee from "./components/olderFee/olderFee";
import AnticipationFeeService from "./service/AnticipationFeeService";
import { AnticipationFeeData } from "./types";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import { T2 } from "../../../../styles/titles";

const AnticipationFee: React.FC = () => {
  const anticipationFeeService = new AnticipationFeeService();
  const [tableData, setTableData] = useState<AnticipationFeeData>({
    adValorem: 0,
    dailyIof: 0,
    additionalIof: 0,
    operationFee: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [filterData, setFilterData] = useState<any>(null);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const data = await anticipationFeeService.getAnticipationFees();

      setTableData({
        adValorem: data.adValorem,
        dailyIof: data.dailyIof,
        additionalIof: data.additionalIof,
        operationFee: data.operationFee,
      });
    } catch (error) {
      console.log("Erro ao buscar nos dados: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterData]);

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />
        <T2>Cadastrar Taxa Antecipação Pontual</T2>

        <OlderFee data={tableData} />
        <InsertFee getFilters={(data) => setFilterData(data)} />
    </Container>
  );
};

export default AnticipationFee;
